export default __webpack_public_path__ + "static/media/villager-example.71e4976f.png";